
const config = {};

config.lid = (label) => (
    {
        label,
        canvas: null,
        image: null,
        path_type: 'polygon',
        path_points: [
            { x: 0, y: 83 },
            { x: 0, y: 243 },
            { x: 265, y: 326 },
            { x: 1000, y: 236 },
            { x: 1000, y: 90 },
            { x: 265, y: 0 }
        ],
        canvas_dims: {
            width: 850,
            height: 400
        },
        path_dims: {
            left: 25,
            top: 70,
            scaleX: 0.801,
            scaleY: 0.801
        },
        save_dims: {
            left: 25,
            top: 70,
            width: 801,
            height: 262
        }
    }
);

config.left = (label) => (
    {
        label,
        canvas: null,
        image: null,
        path_type: 'rect',
        canvas_dims: {
            width: 852,
            height: 300
        },
        path_dims: {
            left: 18,
            top: 100,
            width: 816,
            height: 100
        },
        save_dims: {
            left: 18,
            top: 100,
            width: 816,
            height: 100
        },
        save_dims_1: {
            left: 241,
            top: 100,
            width: 594,
            height: 100
        },
        save_dims_2: {
            left: 18,
            top: 100,
            width: 223,
            height: 100
        }
    }
);

config.right = (label) => (
    {
        label,
        canvas: null,
        image: null,
        path_type: 'rect',
        canvas_dims: {
            width: 852,
            height: 300
        },
        path_dims: {
            left: 18,
            top: 100,
            width: 816,
            height: 100
        },
        save_dims: {
            left: 18,
            top: 100,
            width: 816,
            height: 100
        },
        save_dims_1: {
            left: 18,
            top: 100,
            width: 594,
            height: 100
        },
        save_dims_2: {
            left: 612,
            top: 100,
            width: 223,
            height: 100
        }
    }
);

config.top = (label) => (
    {
        label,
        canvas: null,
        image: null,
        path_type: 'rect',
        canvas_dims: {
            width: 800,
            height: 400
        },
        path_dims: {
            left: 208,
            top: 50,
            width: 384,
            height: 300
        },
        save_dims: {
            left: 208,
            top: 50,
            width: 384,
            height: 300
        }
    }
);

config.bottom = (label) => (
    {
        label,
        canvas: null,
        image: null,
        path_type: 'rect',
        canvas_dims: {
            width: 800,
            height: 400
        },
        path_dims: {
            left: 220,
            top: 50,
            width: 357,
            height: 300
        },
        save_dims: {
            left: 220,
            top: 50,
            width: 357,
            height: 300
        }
    }
);

module.exports = config;
